module.exports = __webpack_public_path__ + "static/media/11.0616567f.jpg";